import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, ActionIconProps } from '@mantine/core';

export interface KeyValuePairInputAddButtonProps {
  disabled: boolean;
  handleAddPair: () => void;
  addButtonProps: ActionIconProps;
}

export function KeyValuePairInputAddButton({
  disabled,
  handleAddPair,
  addButtonProps,
}: KeyValuePairInputAddButtonProps) {
  return (
    <ActionIcon
      data-testid="button-add-key-value-pair"
      disabled={disabled}
      onClick={handleAddPair}
      color="blue"
      variant="filled"
      h={36}
      miw={36}
      {...addButtonProps}
    >
      <FontAwesomeIcon icon={faPlusCircle} />
    </ActionIcon>
  );
}
